import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/nft_default_image.png'


const _withScopeId = n => (_pushScopeId("data-v-12a0c310"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail" }
const _hoisted_2 = { class: "detail-title" }
const _hoisted_3 = { class: "s-title" }
const _hoisted_4 = { class: "detail-content" }
const _hoisted_5 = { class: "item first" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "text clickable" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "text clickable" }
const _hoisted_20 = { class: "copy" }
const _hoisted_21 = {
  id: "detailVal",
  style: {"width":"0","height":"0","opacity":"0"}
}
const _hoisted_22 = { class: "item" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "content" }
const _hoisted_29 = {
  class: "text clickable",
  href: "nftInfo.Site"
}
const _hoisted_30 = {
  key: 0,
  class: "detail-list"
}
const _hoisted_31 = { class: "tab" }
const _hoisted_32 = { class: "first" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "title" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = {
  key: 1,
  class: "detail-list"
}
const _hoisted_40 = { class: "tab" }
const _hoisted_41 = { class: "first" }
const _hoisted_42 = { class: "title" }
const _hoisted_43 = { class: "title" }
const _hoisted_44 = { class: "title" }
const _hoisted_45 = { class: "title" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = {
  key: 2,
  class: "list"
}
const _hoisted_49 = { class: "token-wrapper" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["src"]
const _hoisted_52 = {
  key: 1,
  src: _imports_0
}
const _hoisted_53 = { class: "wrapper" }
const _hoisted_54 = { class: "title" }
const _hoisted_55 = { class: "text" }
const _hoisted_56 = { class: "wrapper1" }
const _hoisted_57 = { class: "title" }
const _hoisted_58 = { class: "text" }
const _hoisted_59 = { key: 3 }
const _hoisted_60 = {
  key: 2,
  class: "detail-list"
}
const _hoisted_61 = { class: "tab" }
const _hoisted_62 = { class: "first" }
const _hoisted_63 = { class: "title" }
const _hoisted_64 = { class: "title" }
const _hoisted_65 = { class: "title" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = {
  key: 2,
  class: "list"
}
const _hoisted_69 = { class: "token-wrapper" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["src"]
const _hoisted_72 = {
  key: 1,
  src: _imports_0
}
const _hoisted_73 = { class: "wrapper" }
const _hoisted_74 = { class: "title" }
const _hoisted_75 = { class: "text" }

import { ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  getERC20,
  getERC20Txs,
  getERC20Holders,
  getNft,
  getNftTx,
  getNftUsers,
  getNftTokens,
  getERC1155,
  getERC1155Txs,
  getERC1155Holders,
  getERC1155Users,
  getContractEvents,
} from "@/api/_common";
import { CONTRACT_TYPE, CSV_REQUEST_SIZE } from "@/utils/constant";
import HelperTools from "@/utils/helper";
import Clipboard from "clipboard";
import { ElMessage } from "element-plus";
import t from "@/utils/en";
import { useMq } from "vue3-mq";
import { eventDictionary } from "@/utils/event";
import List from "@/components/List.vue";
import Title from "@/components/SecondaryTitle.vue";
import { ElIcon } from "element-plus";
import { CopyDocument } from "@element-plus/icons";
import { fromWei } from "@/utils/use-format";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const contractType = ref(-1);

const pageSize = 10;
const tokenPageSize = 8;
const routeName = "ContractDetail";
const currentPage = ref(1);

const ERC20Tabs = ["transfers", "holders", "events"];
const ERC721Tabs = ["transfers", "holders", "inventory", "events"];
const ERC1155Tabs = ["transfers", "holders", "inventory"];

const currentTab = ref(ERC20Tabs[0]);

const contractInfo = ref({
  Contract: "",
  Name: "",
  TotalSupply: 0,
  AddressNum: 0,
  TransferNum: 0,
  Uri: "",
  Site: "",
});
const txs = ref({
  TransactionDetails: [],
  TotalCount: 0,
});
const holders = ref({
  ERC20HolderInfos: [],
  NFTUsers: [],
  ERC1155Users: [],
  TotalCount: 0,
});
const tokens = ref({
  NFTTokenInfos: [],
  ERC1155TokenInfos: [],
  TotalCount: 0,
});
const events = ref({
  Events: [],
  TotalCount: 0,
});

const generatingHoldersCSV = ref(false);
const currentPercentage = ref(0);

const txRowDataERC20 = ref([
  {
    prop: "Hash",
    label: "shared.txHash",
    method: (row) =>
      `${row.TransactionHash.slice(0, 8)}...${row.TransactionHash.slice(-8)}`,
  },
  {
    prop: "From",
    label: "shared.from",
    method: (row) => `${row.From.slice(0, 8)}...${row.From.slice(-8)}`,
  },
  {
    prop: "To",
    label: "shared.to",
    method: (row) => `${row.To.slice(0, 8)}...${row.To.slice(-8)}`,
  },
  {
    prop: "Value",
    label: "contracts.detail.value",
    method: (row) => row.Value,
  },
]);
const txRowDataERC721 = ref([
  {
    prop: "Hash",
    label: "nft.hash",
    method: (row) =>
      `${row.TransactionHash.slice(0, 8)}...${row.TransactionHash.slice(-8)}`,
  },
  {
    prop: "From",
    label: "nft.from",
    method: (row) => `${row.From.slice(0, 8)}...${row.From.slice(-8)}`,
  },
  {
    prop: "To",
    label: "nft.to",
    method: (row) => `${row.To.slice(0, 8)}...${row.To.slice(-8)}`,
  },
  {
    prop: "TokenId",
    label: "nft.id",
    method: (row) => (row.TokenInfo ? row.TokenInfo.Token : ""),
  },
]);

const holderRowDataERC20 = ref([
  {
    prop: "Rank",
    label: "shared.rank",
    method: (row) => row.Rank,
  },
  {
    prop: "Address",
    label: "shared.owner",
    method: (row) => `${row.Address.slice(0, 8)}...${row.Address.slice(-8)}`,
  },
  {
    prop: "Amount",
    label: "shared.amount",
    method: (row) => row.Amount,
  },
  {
    prop: "Percentage",
    label: "shared.percentage",
    method: (row) => row.Percent,
  },
]);
const holderRowDataERC721 = ref([
  {
    prop: "Rank",
    label: "nft.rank",
    method: (row) => row.Rank,
  },
  {
    prop: "Owner",
    label: "nft.owner",
    method: (row) => `${row.Owner.slice(0, 8)}...${row.Owner.slice(-8)}`,
  },
  {
    prop: "Quantity",
    label: "nft.quantity",
    method: (row) => row.TokenNumber,
  },
  {
    prop: "Percentage",
    label: "nft.percentage",
    method: (row) => row.Percent,
  },
]);
const holderRowDataERC1155 = ref([
  {
    prop: "Owner",
    label: "shared.owner",
    method: (row) => `${row.Owner.slice(0, 16)}...${row.Owner.slice(-16)}`,
  },
  {
    prop: "Amount",
    label: "shared.amount",
    method: (row) => row.Amount,
  },
]);

const eventRowData = ref([
  {
    prop: "EventTransactionHash",
    label: "Transaction Hash",
    method: (row) =>
      `${row.TransactionHash.slice(0, 8)}...${row.TransactionHash.slice(-8)}`,
    number: (row) => `#${row.Number}`,
    timeDifference: (row) => {
      const currentTime = new Date().getTime() / 1000;
      const secondDifference = currentTime - row.Time;
      const minuteDifference = Math.floor(secondDifference / 60);
      const hourDifference = Math.floor(secondDifference / (60 * 60));
      const dayDifference = Math.floor(secondDifference / (60 * 60 * 24));
      return {
        seconds: secondDifference,
        minutes: minuteDifference,
        hours: hourDifference,
        days: dayDifference,
      };
    },
  },
  {
    prop: "EventName",
    label: "Name",
    signature: (eventId) => {
      return `${eventId.slice(0, 10)}`;
    },
    name: (event) => {
      const e = eventDictionary.find((e) => e.eventId === event.EventId);
      if (
        e &&
        e.name === "transfer" &&
        event.Topic1 ===
          "0x0000000000000000000000000000000000000000000000000000000000000000"
      ) {
        return "mint";
      } else if (e) {
        return e.name;
      } else {
        return "";
      }
    },
  },
  {
    prop: "EventLog",
    label: "Topics",
    getTopics: (row) => {
      const event = eventDictionary.find((e) => e.eventId === row.EventId);
      const topicValues = [];
      const topicNames = [];
      for (let i = 1; i < 4; i++) {
        const ti = `Topic${i}`;
        if (event && row[ti] !== "") {
          if (
            event.topics[i - 1] === "from" ||
            event.topics[i - 1] === "to" ||
            event.topics[i - 1] === "owner" ||
            event.topics[i - 1] === "approved"
          ) {
            topicValues.push(`0x${row[ti].slice(-40)}`);
          } else {
            topicValues.push(row[ti]);
          }
        }
        if (event) {
          topicNames.push(event.topics[i - 1]);
        } else {
          topicNames.push(i - 1);
        }
      }
      return {
        topics: {
          topicValues,
          topicNames,
        },
      };
    },
  },
]);

const isERC20 = computed(() => contractType.value === CONTRACT_TYPE.ERC20);
const isERC721 = computed(() => contractType.value === CONTRACT_TYPE.ERC721);
const isERC1155 = computed(() => contractType.value === CONTRACT_TYPE.ERC1155);
const isXs = computed(() => useMq().current === "xs");
const parsedContract = computed(() => {
  if (!contractInfo.value.Contract) {
    return "";
  } else {
    return `${contractInfo.value.Contract.slice(
      0,
      8
    )}...${contractInfo.value.Contract.slice(-8)}`;
  }
});

const getContractType = async () => {
  const res = await getERC20({
    Contract: route.params.Contract,
  }).catch(() => console.error("Error getting contract type"));
  if (res) {
    contractType.value = res.Type;
  }
};

const getERC20ContractDetail = async () => {
  const res = await getERC20({
    Contract: route.params.Contract,
  }).catch(() => console.error("Error fetching erc-20"));
  if (res) {
    contractInfo.value = res;
  }
};
const _getERC20Txs = async (newPage: number) => {
  const res = await getERC20Txs({
    Contract: route.params.Contract,
    PageNo: newPage - 1,
    PageSize: pageSize,
  }).catch(() => console.error("Error fetching erc-20 transactions"));
  if (res) {
    txs.value = res;
  }
};
const _getERC20Holders = async (newPage: number) => {
  const res = await getERC20Holders({
    Contract: route.params.Contract,
    PageNo: newPage - 1,
    PageSize: pageSize,
  }).catch(() => console.error("Error fetching erc-20 holders"));
  if (res) {
    holders.value = res;
    if (holders.value.ERC20HolderInfos) {
      for (let i = 0; i < holders.value.ERC20HolderInfos.length; i++) {
        holders.value.ERC20HolderInfos[i].Rank =
          pageSize * (newPage - 1) + i + 1;
      }
    }
  }
};

const getERC721ContractDetail = async () => {
  const res = await getNft({
    Contract: route.params.Contract,
  }).catch(() => console.error("Error fetching erc-721"));
  if (res) {
    contractInfo.value = res;
  }
};
const _getNftTx = async (newPage: number) => {
  const res = await getNftTx({
    Contract: route.params.Contract,
    PageNo: newPage - 1,
    PageSize: pageSize,
  }).catch(() => console.error("Error fetching erc-721 transactions"));
  if (res) {
    txs.value = res;
  }
};
const _getNftUsers = async (newPage: number) => {
  const res = await getNftUsers({
    Contract: route.params.Contract,
    PageNo: newPage - 1,
    PageSize: pageSize,
  }).catch(() => console.error("Error fetching erc-721 holders"));
  if (res) {
    holders.value = res;
    if (holders.value.NFTUsers) {
      for (let i = 0; i < holders.value.NFTUsers.length; i++) {
        holders.value.NFTUsers[i].Rank = pageSize * (newPage - 1) + i + 1;
      }
    }
  }
};
const _getNftTokens = async (newPage: number) => {
  const res = await getNftTokens({
    Contract: route.params.Contract,
    PageNo: newPage - 1,
    PageSize: tokenPageSize,
  }).catch(() => console.error("Error fetching erc-721 tokens"));
  if (res) {
    tokens.value = res;
  }
};

const getERC1155ContractDetail = async () => {
  const res = await getERC1155({
    Contract: route.params.Contract,
  }).catch(() => console.error("Error fetching erc-1155"));
  if (res) {
    contractInfo.value = res;
  }
};
const _getERC1155Txs = async (newPage: number) => {
  const res = await getERC1155Txs({
    Contract: route.params.Contract,
    PageNo: newPage - 1,
    PageSize: pageSize,
  }).catch(() => console.error("Error fetching erc-1155 transactions"));
  if (res) {
    txs.value = res;
  }
};
const _getERC1155Holders = async (newPage: number) => {
  const res = await getERC1155Users({
    Contract: route.params.Contract,
    PageNo: newPage - 1,
    PageSize: pageSize,
  }).catch(() => console.error("Error fetching erc-1155 holders"));
  if (res) {
    holders.value = res;
  }
};
const _getERC1155Users = async (newPage: number) => {
  const res = await getERC1155Holders({
    Contract: route.params.Contract,
    PageNo: newPage - 1,
    PageSize: tokenPageSize,
  }).catch(() => console.error("Error fetching erc-1155 tokens"));
  if (res) {
    tokens.value = res;
  }
};

const _getContractEvents = async (newPage: number) => {
  const res = await getContractEvents({
    Contract: route.params.Contract,
    PageNo: newPage,
    PageSize: pageSize,
  }).catch(() => console.error("Error fetching contract events"));
  if (res) {
    events.value = res;
  }
};

const setTab = () => {
  if (route.query.tab) {
    currentTab.value = String(route.query.tab);
  }
};
const handleCurrentChange = async (newPage: number) => {
  await router.replace({
    query: {
      ...route.query,
      page: newPage,
    },
  });
  currentPage.value = newPage;
};

const load = async () => {
  await getContractType();
  setTab();
  if (isERC20.value) {
    await getERC20ContractDetail();
    if (!route.query.page || !route.query.tab) {
      await router.replace({
        query: {
          page: 1,
          tab: ERC20Tabs[0],
        },
      });
    } else {
      if (route.query.tab === ERC20Tabs[0]) {
        await _getERC20Txs(Number(route.query.page));
      } else if (route.query.tab === ERC20Tabs[1]) {
        await _getERC20Holders(Number(route.query.page));
      } else if (route.query.tab === ERC20Tabs[2]) {
        await _getContractEvents(Number(route.query.page));
      }
      currentPage.value = Number(route.query.page);
    }
  } else if (isERC721.value) {
    await getERC721ContractDetail();
    if (!route.query.page || !route.query.tab) {
      await router.replace({
        query: {
          page: 1,
          tab: ERC721Tabs[0],
        },
      });
    } else {
      if (route.query.tab === ERC721Tabs[0]) {
        await _getNftTx(Number(route.query.page));
      } else if (route.query.tab === ERC721Tabs[1]) {
        await _getNftUsers(Number(route.query.page));
      } else if (route.query.tab === ERC721Tabs[2]) {
        await _getNftTokens(Number(route.query.page));
      } else if (route.query.tab === ERC721Tabs[3]) {
        await _getContractEvents(Number(route.query.page));
      }
      currentPage.value = Number(route.query.page);
    }
  } else if (isERC1155.value) {
    await getERC1155ContractDetail();
    if (!route.query.page || !route.query.tab) {
      await router.replace({
        query: {
          page: 1,
          tab: ERC1155Tabs[0],
        },
      });
    } else {
      if (route.query.tab === ERC1155Tabs[0]) {
        await _getERC1155Txs(Number(route.query.page));
      } else if (route.query.tab === ERC1155Tabs[1]) {
        await _getERC1155Holders(Number(route.query.page));
      } else if (route.query.tab === ERC1155Tabs[2]) {
        await _getERC1155Users(Number(route.query.page));
      }
      currentPage.value = Number(route.query.page);
    }
  }
};
load();

watch(
  () => route.query,
  async (n) => {
    if (router.currentRoute.value.name === routeName) {
      if (isERC20.value) {
        if (route.query.tab === ERC20Tabs[0]) {
          await _getERC20Txs(Number(n.page));
        } else if (route.query.tab === ERC20Tabs[1]) {
          await _getERC20Holders(Number(n.page));
        } else if (route.query.tab === ERC20Tabs[2]) {
          await _getContractEvents(Number(n.page));
        }
        currentPage.value = Number(n.page);
      } else if (isERC721.value) {
        if (route.query.tab === ERC721Tabs[0]) {
          await _getNftTx(Number(n.page));
        } else if (route.query.tab === ERC721Tabs[1]) {
          await _getNftUsers(Number(n.page));
        } else if (route.query.tab === ERC721Tabs[2]) {
          await _getNftTokens(Number(n.page));
        } else if (route.query.tab === ERC721Tabs[3]) {
          await _getContractEvents(Number(route.query.page));
        }
        currentPage.value = Number(n.page);
      } else if (isERC1155.value) {
        if (route.query.tab === ERC721Tabs[0]) {
          await _getERC1155Txs(Number(n.page));
        } else if (route.query.tab === ERC721Tabs[1]) {
          await _getERC1155Holders(Number(n.page));
        } else if (route.query.tab === ERC721Tabs[2]) {
          await _getERC1155Users(Number(n.page));
        }
        currentPage.value = Number(n.page);
      }
    }
  }
);

const tabSwitch = async (newTab: number) => {
  if (isERC20.value) {
    await router.replace({
      query: {
        page: 1,
        tab: ERC20Tabs[newTab],
      },
    });
    currentTab.value = ERC20Tabs[newTab];
  } else if (isERC721.value) {
    await router.replace({
      query: {
        page: 1,
        tab: ERC721Tabs[newTab],
      },
    });
    currentTab.value = ERC721Tabs[newTab];
  } else if (isERC1155.value) {
    await router.replace({
      query: {
        page: 1,
        tab: ERC1155Tabs[newTab],
      },
    });
    currentTab.value = ERC1155Tabs[newTab];
  }
};

const toTx = (row) => {
  router.push({ name: "Tx", params: { Hash: row.TransactionHash } });
};
const toToken = (token) => {
  router.push({
    name: isERC721.value ? "ERC-721TokenDetail" : "ERC-1155TokenDetail",
    params: {
      Contract: route.params.Contract,
      NFT: route.params.Contract,
      Token: token,
    },
  });
};

const copyDetailVal = () => {
  let clipboard = new Clipboard(".copy-success");
  clipboard.on("success", function (e) {
    e.clearSelection();
  });
  copied();
};
const copied = () => {
  ElMessage(t.message.copysuccess);
};

const exportHoldersERC20 = async () => {
  const titles = ["Rank", "Owner", "Amount", "Percentage"];
  const csvDataPreprocessed = await getPreProcessedData();
  const csvData = csvDataPreprocessed
    .map((value, index) => {
      return {
        Rank: index + 1,
        Owner: value.Address,
        Amount: value.Amount,
        Percentage: value.Percent,
      };
    })
    .map((value) => [value.Rank, value.Owner, value.Amount, value.Percentage]);
  generateCSV(titles, csvData);
};

const exportHoldersERC721 = async () => {
  const titles = ["Rank", "Owner", "Quantity", "Percentage"];
  const csvDataPreprocessed = await getPreProcessedData();
  const csvData = csvDataPreprocessed
    .map((value, index) => {
      return {
        Rank: index + 1,
        Owner: value.Owner,
        Quantity: value.TokenNumber,
        Percentage: value.Percent,
      };
    })
    .map((value) => [
      value.Rank,
      value.Owner,
      value.Quantity,
      value.Percentage,
    ]);
  generateCSV(titles, csvData);
};

const exportHoldersERC1155 = async () => {
  const titles = ["Owner", "Amount"];
  const csvDataPreprocessed = await getPreProcessedData();
  const csvData = csvDataPreprocessed
    .map((value) => {
      return {
        Owner: value.Owner,
        Amount: value.Amount,
      };
    })
    .map((value) => [value.Owner, value.Amount]);
  generateCSV(titles, csvData);
};

const generateCSV = (titles: string[], data: string[][]) => {
  const rows = [titles, ...data];
  const csvContent =
    "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n");
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${contractInfo.value.Name}_holders.csv`);
  document.body.appendChild(link);
  link.click();
  generatingHoldersCSV.value = false;
  currentPercentage.value = 0;
};

const getPreProcessedData = async () => {
  const numberOfPages = Math.ceil(holders.value.TotalCount / 100);
  if (numberOfPages > 3) {
    generatingHoldersCSV.value = true;
  }
  let csvDataPreprocessed = [];
  const payload = {
    Contract: route.params.Contract,
    PageSize: CSV_REQUEST_SIZE,
  };
  for (let i = 0; i < numberOfPages; i++) {
    let res;
    if (isERC20.value) {
      res = await getERC20Holders({
        ...payload,
        PageNo: i,
      });
      csvDataPreprocessed = csvDataPreprocessed.concat(res.ERC20HolderInfos);
    } else if (isERC721.value) {
      res = await getNftUsers({
        ...payload,
        PageNo: i,
      });
      csvDataPreprocessed = csvDataPreprocessed.concat(res.NFTUsers);
    } else if (isERC1155.value) {
      res = await getERC1155Users({
        ...payload,
        PageNo: i,
      });
      csvDataPreprocessed = csvDataPreprocessed.concat(res.ERC1155Users);
    }
    currentPercentage.value = Math.round((i / numberOfPages) * 100);
  }
  return csvDataPreprocessed;
};

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Title, {
        img: contractInfo.value.Uri,
        title: contractInfo.value.Name
      }, null, 8, ["img", "title"])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("nfttoken.overview")), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("nft.total")) + ":", 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(isERC20)
              ? _unref(fromWei)(contractInfo.value.TotalSupply)
              : _unref(HelperTools).toFinancialVal(contractInfo.value.TotalSupply)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("nft.holders")) + ":", 1),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(HelperTools).toFinancialVal(contractInfo.value.AddressNum)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("nft.contract")) + ":", 1),
        _createElementVNode("div", _hoisted_15, [
          (_unref(isXs))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(parsedContract)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(contractInfo.value.Contract), 1)
              ])),
          _createVNode(_unref(ElIcon), { size: 16 }, {
            default: _withCtx(() => [
              _createVNode(_unref(CopyDocument), {
                size: 16,
                class: "el-icon-copy-document copy-success",
                "data-clipboard-target": "#detailVal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (copyDetailVal()))
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(contractInfo.value.Contract), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("nft.tx")) + ":", 1),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(HelperTools).toFinancialVal(contractInfo.value.TransferNum)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("nft.site")) + ":", 1),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("a", _hoisted_29, _toDisplayString(contractInfo.value.Site), 1)
        ])
      ])
    ]),
    (_unref(isERC20))
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", {
              class: "item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (tabSwitch(0)))
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("contracts.detail.tx")), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(currentTab.value === ERC20Tabs[0] ? 'line active' : 'line')
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", {
              class: "item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (tabSwitch(1)))
            }, [
              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("contracts.detail.holders")), 1),
              _createElementVNode("div", {
                class: _normalizeClass(currentTab.value === ERC20Tabs[1] ? 'line active' : 'line')
              }, null, 2)
            ]),
            _createElementVNode("div", {
              class: "item",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (tabSwitch(2)))
            }, [
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("contracts.detail.events")), 1),
              _createElementVNode("div", {
                class: _normalizeClass(currentTab.value === ERC20Tabs[2] ? 'line active' : 'line')
              }, null, 2)
            ])
          ]),
          (currentTab.value === ERC20Tabs[0])
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createVNode(List, {
                  style: {"margin-top":"0","padding":"0"},
                  data: txs.value.TransactionDetails,
                  handle: toTx,
                  handleCurrentChange: handleCurrentChange,
                  rowDatas: txRowDataERC20.value,
                  total: txs.value.TotalCount,
                  "current-page": currentPage.value
                }, null, 8, ["data", "rowDatas", "total", "current-page"])
              ]))
            : _createCommentVNode("", true),
          (currentTab.value === ERC20Tabs[1])
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(List, {
                  style: {"margin-top":"0","padding":"0"},
                  data: holders.value.ERC20HolderInfos,
                  handleCurrentChange: handleCurrentChange,
                  rowDatas: holderRowDataERC20.value,
                  total: holders.value.TotalCount,
                  "current-page": currentPage.value,
                  csvExport: true,
                  csvGenerating: generatingHoldersCSV.value,
                  csvPercentage: currentPercentage.value,
                  handleCSVExport: exportHoldersERC20
                }, null, 8, ["data", "rowDatas", "total", "current-page", "csvGenerating", "csvPercentage"])
              ]))
            : _createCommentVNode("", true),
          (currentTab.value === ERC20Tabs[2])
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(List, {
                  style: {"margin-top":"0","padding":"0"},
                  data: events.value.Events,
                  handleCurrentChange: handleCurrentChange,
                  rowDatas: eventRowData.value,
                  total: events.value.TotalCount,
                  firstColumnWidth: "250",
                  secondColumnWidth: "250",
                  "current-page": currentPage.value
                }, null, 8, ["data", "rowDatas", "total", "current-page"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_unref(isERC721))
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", {
                class: "item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (tabSwitch(0)))
              }, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("nft.tx")), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(currentTab.value === ERC721Tabs[0] ? 'line active' : 'line')
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", {
                class: "item",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (tabSwitch(1)))
              }, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("nft.holders")), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(currentTab.value === ERC721Tabs[1] ? 'line active' : 'line')
                }, null, 2)
              ]),
              _createElementVNode("div", {
                class: "item",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (tabSwitch(2)))
              }, [
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t("nft.inventory")), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(currentTab.value === ERC721Tabs[2] ? 'line active' : 'line')
                }, null, 2)
              ]),
              _createElementVNode("div", {
                class: "item",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (tabSwitch(3)))
              }, [
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("nft.events")), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(currentTab.value === ERC721Tabs[3] ? 'line active' : 'line')
                }, null, 2)
              ])
            ]),
            (currentTab.value === ERC721Tabs[0])
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createVNode(List, {
                    style: {"margin-top":"0","padding":"0"},
                    data: txs.value.TransactionDetails,
                    handle: toTx,
                    handleCurrentChange: handleCurrentChange,
                    rowDatas: txRowDataERC721.value,
                    total: txs.value.TotalCount,
                    "current-page": currentPage.value
                  }, null, 8, ["data", "rowDatas", "total", "current-page"])
                ]))
              : _createCommentVNode("", true),
            (currentTab.value === ERC721Tabs[1])
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createVNode(List, {
                    style: {"margin-top":"0","padding":"0"},
                    data: holders.value.NFTUsers,
                    handleCurrentChange: handleCurrentChange,
                    rowDatas: holderRowDataERC721.value,
                    total: holders.value.TotalCount,
                    "current-page": currentPage.value,
                    csvExport: true,
                    csvGenerating: generatingHoldersCSV.value,
                    csvPercentage: currentPercentage.value,
                    handleCSVExport: exportHoldersERC721
                  }, null, 8, ["data", "rowDatas", "total", "current-page", "csvGenerating", "csvPercentage"])
                ]))
              : _createCommentVNode("", true),
            (currentTab.value === ERC721Tabs[2])
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tokens.value.NFTTokenInfos, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item",
                        key: index,
                        onClick: ($event: any) => (toToken(item.Token))
                      }, [
                        (item.Profile && item.Profile.image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.Profile.image
                            }, null, 8, _hoisted_51))
                          : (_openBlock(), _createElementBlock("img", _hoisted_52)),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t("nft.id")) + ":", 1),
                          _createElementVNode("div", _hoisted_55, _toDisplayString(item.Token), 1)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t("nft.owner")) + ":", 1),
                          _createElementVNode("div", _hoisted_58, _toDisplayString(item.Owner.slice(0, 8)) + "..." + _toDisplayString(item.Owner.slice(-8)), 1)
                        ])
                      ], 8, _hoisted_50))
                    }), 128))
                  ]),
                  _createVNode(_component_el_pagination, {
                    onCurrentChange: handleCurrentChange,
                    layout: "prev, pager, next",
                    "page-size": tokenPageSize,
                    "current-page": currentPage.value,
                    total: tokens.value.TotalCount
                  }, null, 8, ["current-page", "total"])
                ]))
              : _createCommentVNode("", true),
            (currentTab.value === ERC721Tabs[3])
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createVNode(List, {
                    style: {"margin-top":"0","padding":"0"},
                    data: events.value.Events,
                    handleCurrentChange: handleCurrentChange,
                    rowDatas: eventRowData.value,
                    total: events.value.TotalCount,
                    firstColumnWidth: "250",
                    secondColumnWidth: "250",
                    "current-page": currentPage.value
                  }, null, 8, ["data", "rowDatas", "total", "current-page"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    (_unref(isERC1155))
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", {
              class: "item",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (tabSwitch(0)))
            }, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("contracts.detail.tx")), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(currentTab.value === ERC1155Tabs[0] ? 'line active' : 'line')
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", {
              class: "item",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (tabSwitch(1)))
            }, [
              _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t("contracts.detail.holders")), 1),
              _createElementVNode("div", {
                class: _normalizeClass(currentTab.value === ERC1155Tabs[1] ? 'line active' : 'line')
              }, null, 2)
            ]),
            _createElementVNode("div", {
              class: "item",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (tabSwitch(2)))
            }, [
              _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("nft.inventory")), 1),
              _createElementVNode("div", {
                class: _normalizeClass(currentTab.value === ERC1155Tabs[2] ? 'line active' : 'line')
              }, null, 2)
            ])
          ]),
          (currentTab.value === ERC1155Tabs[0])
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _createVNode(List, {
                  style: {"margin-top":"0","padding":"0"},
                  data: txs.value.TransactionDetails,
                  handle: toTx,
                  handleCurrentChange: handleCurrentChange,
                  rowDatas: txRowDataERC721.value,
                  total: txs.value.TotalCount,
                  "current-page": currentPage.value
                }, null, 8, ["data", "rowDatas", "total", "current-page"])
              ]))
            : _createCommentVNode("", true),
          (currentTab.value === ERC1155Tabs[1])
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _createVNode(List, {
                  style: {"margin-top":"0","padding":"0"},
                  data: holders.value.ERC1155Users,
                  handleCurrentChange: handleCurrentChange,
                  rowDatas: holderRowDataERC1155.value,
                  total: holders.value.TotalCount,
                  "current-page": currentPage.value,
                  csvExport: true,
                  csvGenerating: generatingHoldersCSV.value,
                  csvPercentage: currentPercentage.value,
                  handleCSVExport: exportHoldersERC1155
                }, null, 8, ["data", "rowDatas", "total", "current-page", "csvGenerating", "csvPercentage"])
              ]))
            : _createCommentVNode("", true),
          (currentTab.value === ERC1155Tabs[2])
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tokens.value.ERC1155TokenInfos, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item",
                      key: index,
                      onClick: ($event: any) => (toToken(item.Token))
                    }, [
                      (item.Profile && item.Profile.image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.Profile.image
                          }, null, 8, _hoisted_71))
                        : (_openBlock(), _createElementBlock("img", _hoisted_72)),
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t("nft.id")) + ":", 1),
                        _createElementVNode("div", _hoisted_75, _toDisplayString(item.Token), 1)
                      ])
                    ], 8, _hoisted_70))
                  }), 128))
                ]),
                _createVNode(_component_el_pagination, {
                  onCurrentChange: handleCurrentChange,
                  layout: "prev, pager, next",
                  "page-size": tokenPageSize,
                  "current-page": currentPage.value,
                  total: tokens.value.TotalCount
                }, null, 8, ["current-page", "total"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})